import { useQuery } from '@tanstack/react-query';
import { opsApi } from '../api/client';

/** Authenticated client-portal queries (role=client logins, /api/portal/*). */

export function usePortalProjects() {
  return useQuery({ queryKey: ['portal-projects'], queryFn: opsApi.portalProjects });
}

export function usePortalProjectView(projectId: string | undefined) {
  return useQuery({
    queryKey: ['portal-project', projectId],
    queryFn: () => opsApi.portalProjectView(projectId!),
    enabled: Boolean(projectId),
  });
}

/**
 * Progress photo as a blob object-URL, fetched with the bearer token (an
 * <img src> can't carry an Authorization header). Cached for the session —
 * photos are immutable once uploaded.
 */
export function usePortalPhotoSrc(projectId: string, photoId: string): string | null {
  const { data } = useQuery({
    queryKey: ['portal-photo', projectId, photoId],
    queryFn: async () => URL.createObjectURL(await opsApi.portalPhotoBlob(projectId, photoId)),
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return data ?? null;
}
